// extracted by mini-css-extract-plugin
module.exports = {"two-grid":"styles-m__two-grid__CSAYP","ul-list":"styles-m__ul-list__ZqRw3"};